(function () {

  function initTruPahadiStats(section) {

    if (!section) return;

    const cards = section.querySelectorAll('.tp-stat-card');
    const counters = section.querySelectorAll('.tp-count-number');

    if (!counters.length) return;


    /*
     * COUNT ANIMATION
     */

    function animateCounter(element) {

      if (element.dataset.counted === 'true') {
        return;
      }

      element.dataset.counted = 'true';

      const target = parseInt(
        element.getAttribute('data-target'),
        10
      );

      if (isNaN(target)) {
        return;
      }

      const duration = 1800;
      const startTime = performance.now();


      function updateCounter(currentTime) {

        const elapsed = currentTime - startTime;

        const progress = Math.min(
          elapsed / duration,
          1
        );


        /*
         * Smooth ease-out animation
         */

        const easeOut = 1 - Math.pow(
          1 - progress,
          3
        );


        const currentNumber = Math.floor(
          easeOut * target
        );


        element.textContent = currentNumber;


        if (progress < 1) {

          requestAnimationFrame(
            updateCounter
          );

        } else {

          /*
           * Final value
           */

          element.textContent = target + '+';

        }

      }


      requestAnimationFrame(
        updateCounter
      );

    }


    /*
     * START COUNT WHEN SECTION
     * BECOMES VISIBLE
     */

    if ('IntersectionObserver' in window) {

      const observer = new IntersectionObserver(
        function (entries, observerInstance) {

          entries.forEach(function (entry) {

            if (entry.isIntersecting) {

              counters.forEach(function (counter) {

                animateCounter(counter);

              });

              observerInstance.unobserve(
                entry.target
              );

            }

          });

        },
        {
          threshold: 0.25
        }
      );


      observer.observe(section);

    } else {

      /*
       * Fallback for older browsers
       */

      counters.forEach(function (counter) {

        animateCounter(counter);

      });

    }


    /*
     * MOBILE TOUCH EFFECT
     */

    cards.forEach(function (card) {

      card.addEventListener(
        'touchstart',
        function () {

          cards.forEach(function (item) {
            item.classList.remove(
              'tp-touch-active'
            );
          });

          card.classList.add(
            'tp-touch-active'
          );

        },
        {
          passive: true
        }
      );


      card.addEventListener(
        'touchend',
        function () {

          setTimeout(function () {

            card.classList.remove(
              'tp-touch-active'
            );

          }, 500);

        },
        {
          passive: true
        }
      );

    });

  }


  /*
   * NORMAL PAGE LOAD
   */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      document
        .querySelectorAll('.tp-stats-section')
        .forEach(function (section) {

          initTruPahadiStats(section);

        });

    }
  );


  /*
   * SHOPIFY THEME EDITOR
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '.tp-stats-section'
        );

      if (section) {

        initTruPahadiStats(section);

      }

    }
  );


  /*
   * SHOPIFY SECTION REORDER
   */

  document.addEventListener(
    'shopify:section:reorder',
    function () {

      document
        .querySelectorAll('.tp-stats-section')
        .forEach(function (section) {

          initTruPahadiStats(section);

        });

    }
  );

})();